import type { EasyEditorAutosaveConfig, EasyEditorCkeditorGlobal } from "../types/easyEditor";

const AUTOSAVE_WAITING_TIME_MS = 1000;
const AUTOSAVE_STORAGE_KEY_PREFIX = "ckeditor-autosave-";

export const getAutosaveStorageKey = (storageId: string): string => {
  return `${AUTOSAVE_STORAGE_KEY_PREFIX}${storageId}`;
};

const createCkeditorGlobal = (): EasyEditorCkeditorGlobal => ({
  instances: {},
  initialValue: {},
  isDirty: {},
  autosavedRestored: {},
  autosaveStorageIds: {},
});

export const getCkeditorGlobal = (): EasyEditorCkeditorGlobal => {
  if (!window.CKEDITOR) {
    window.CKEDITOR = createCkeditorGlobal();
  }

  return window.CKEDITOR;
};

export const createAutosaveConfig = (storageKey: string): EasyEditorAutosaveConfig => ({
  save: async editor => {
    localStorage.setItem(storageKey, editor.getData());
  },
  waitingTime: AUTOSAVE_WAITING_TIME_MS,
});

export const registerEditorInstance = ({
  id,
  editor,
  restoredData,
}: {
  id: string;
  editor: EasyEditorCkeditorGlobal["instances"][string];
  restoredData: boolean;
}): void => {
  const ckeditorGlobal = getCkeditorGlobal();

  ckeditorGlobal.instances[id] = editor;
  ckeditorGlobal.initialValue[id] = editor.getData();
  ckeditorGlobal.isDirty[id] = false;
  ckeditorGlobal.autosavedRestored[id] = restoredData;
};

export const unregisterEditorInstance = (id: string): void => {
  const ckeditorGlobal = getCkeditorGlobal();

  delete ckeditorGlobal.instances[id];
  delete ckeditorGlobal.initialValue[id];
  delete ckeditorGlobal.isDirty[id];
  delete ckeditorGlobal.autosavedRestored[id];
  delete ckeditorGlobal.autosaveStorageIds[id];
};
